import { useSuspenseQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants';
import {
  SearchQueryFactory,
  type SearchParameters,
  type Filters,
} from 'app/domain';
import useApi from '../useApi';

const queryFactory = new SearchQueryFactory();

const useFilters = (searchParameters: SearchParameters) => {
  const { filtersService } = useApi();
  const query = queryFactory.fromSearchParameters(searchParameters);

  const { data } = useSuspenseQuery<Filters>({
    queryKey: [...QUERY_KEYS.filters, query],
    queryFn: async () => await filtersService.getAll(query),
  });

  return { filters: data };
};

export default useFilters;
